<template>
  <layout-basic>
      <v-container id="billing-sec">
        <!-- <div v-if="company.state == 2 || company.state == 4">
          <v-banner
            lines="one"
            icon="mdi-lock"
            color="deep-purple-accent-4"
            class="my-4 alert alert-light">
              <v-banner-text style="font-weight: bold;" v-if="company.state == 2">
                Your Free trial has been expired.
              </v-banner-text>
              <v-banner-text style="font-weight: bold;" v-if="company.state == 4">
                Your Membership has been suspended.
              </v-banner-text>
          </v-banner>
        </div> -->
        <v-row>
          <v-col class="Full-Course-Library-Title">
            Account Status
          </v-col>
        </v-row>
        <div class="text-left pt-6 pb-6 mt-6 status-label">
              <v-row class="py-0">
                <v-col md="3" class="py-0">Current Status:</v-col>
                <v-col md="9" class="py-0">{{ company.state_description }} 
                <!-- <v-btn
                  class="ml-6 bold"
                  color="primary"
                  @click="cancelAccount"
                  v-if="company.state == 3"
                  >Cancel Account</v-btn> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col md="3" class="pt-3 pb-0">Current Users:</v-col>
                <v-col md="9" class="pt-3 pb-0">{{ company.total_employees }}</v-col>
              </v-row>
              <v-row>
                <v-col md="3" class="pt-6 pb-0">Current Banding:</v-col>
                <v-col md="9" class="pt-6 pb-0">{{ bandingDescription }}
                <!-- <v-btn
                  class="ml-6 bold"
                  color="primary"
                  @click="showUpgradeAccountPanel"
                  v-if="company.state == 3"
                  >Change Banding</v-btn> -->
                  <v-btn
                    class="ml-6 bold"
                    color="primary"
                    to="/billing"
                    v-if="canBuyImprove"
                  >Get started / Buy IMPROVE</v-btn>
                </v-col>
                <!-- </v-col> -->
              </v-row>
              <v-row>
                <v-col md="3" class="pt-3 pb-0">Date Subscribed:</v-col>
                <v-col md="9" class="pt-3 pb-0">{{ company.subscription_date_formatted }}</v-col>
              </v-row>
              <v-row v-if="company.state == 1">
                <v-col md="3" class="pt-6 pb-0">Free Trial Expiry:</v-col>
                <v-col md="9" class="pt-6 pb-0">{{ company.trial_expired_date}}</v-col>
              </v-row>
              <v-row>
                <v-col md="3" class="pt-3 pb-0">Renewal Date:</v-col>
                <v-col md="9" class="pt-3 pb-0">{{ company.renewal_at }}</v-col>
              </v-row>
              <v-row>
                <v-col md="3" class="pt-6 pb-0">Billing Frequency:</v-col>
                <v-col md="9" class="pt-6 pb-0">{{ company.invoice_type}}</v-col>
              </v-row>
              <!-- <v-row v-else>
                <v-col md="3" class="pt-6 pb-0">Next Payment Date:</v-col>
                <v-col md="9" class="pt-6 pb-0">{{ company.renewal_date_formatted }}</v-col>
              </v-row>
              <v-row>
                <v-col md="3" class="pt-6 pb-0">Billing Frequency:</v-col>
                <v-col md="9" class="pt-6 pb-0">{{ paymentMethodType }}</v-col>
              </v-row> -->
              <div v-if="company.state == 1 || company.state == 2 || company.state == 4" class="text-center">
                <v-banner
                  lines="two"
                  color="deep-purple-accent-4"
                  class="mt-10 alert alert-light text-center mr-auto ml-auto" style="width: 50%; word-wrap: break-word;">
                    <v-banner-text >
                      Welcome to your free trial of <b> IMPROVE! </b> <br>
                      Choose a plan to go live, or email <b> help@improve.online </b> if you would like to extend your free trial or discuss your account.
                    </v-banner-text>
                </v-banner>
                <v-btn
                  class="mt-6"
                  color="primary"
                  large
                  depressed
                  to="/billing"
                >Get started / Buy IMPROVE</v-btn>
              </div>
        </div>
      </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
// import UpgradeAccount from "@/components/admin/finance/UpgradeAccount";
// import PaymentMethod from "@/components/admin/finance/PaymentMethod";
import companyAPI from "@/api/company.js";
import { EventBus } from "@/event-bus.js";
export default {
  name: "Profile",
  components: {
    LayoutBasic
  },
  data() {
    return {
      company: [],
      params: "",
      messages: {},
      successMessage: "Company Information Successfully Updated.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct."
    };
  },
  computed: {
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    },
    bandingDescription: function() {
      return this.company.hasOwnProperty("banding_description")
        ? this.company.banding_description.name
        : "";
    },
    canBuyImprove: function() {
      return this.company.state == 1 || this.company.state == 2 || this.company.state == 4;
    }
  },
  mounted() {
    this.getProfile();
    this.getAccountInfo();
    this.setEventBus();
  },
  methods: {
    getProfile() {
      companyAPI.getCompanyById(this.$store.getters.user.company.data.id,this.params).then(response => {
        this.company = response.data.data;
      });
    },
    cancelAccount() {
      this.financeLoading = true;
      companyAPI.cancelAccount().then(response => {
        this.getAccountInfo();
        this.financeLoading = false;
      })
      .catch(err => {
        this.financeLoading = false;
        this.messages = this.$gf.errorResponse(err);
        let errMsg = err.response.data.message;
        if(errMsg) {
          this.errorMessage = errMsg;
          this.$snotify.error(errMsg);
        }else{
          this.$snotify.error(this.errorMessage);
        }
      });
    },
    getAccountInfo() {
      this.financeLoading = true;
      companyAPI.getAccountInfo().then(response => {
        this.company = response.data.data;
        this.financeLoading = false;
      });
    },
    setEventBus() {
      EventBus.$on("COMPANY_UPDATED", () => {
        this.getAccountInfo();
      });
      EventBus.$on("PAYMENT_METHOD_ADDED", () => {
        this.getAccountInfo();
      });
      EventBus.$on("ACCOUNT_UPGRADED", () => {
        this.getAccountInfo();
      });
    },
    // showUpgradeAccountPanel() {
    //   this.$showPanel({
    //     component: UpgradeAccount
    //   });
    // },
    // showAddPaymentPanel() {
    //   this.$showPanel({
    //     component: PaymentMethod,
    //     props: {
    //       banding: this.company.banding,
    //       company_state: this.company.state
    //     }
    //   });
    // }
  }
};
</script>
<style>
.theme--light.v-banner .v-banner__wrapper {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    background-color: #fff3cd;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
}
</style>
